import React, {lazy, useContext, useEffect, useRef, useState, useTransition} from 'react';
import './Imprint.css';
import { LocaleContext, OverlayContext, ScrollContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { LoadState } from '../common/enums.mjs';
import { Link } from 'react-router-dom';
import { ConsumerContext } from '..';
import { LinkSmart } from '../common/Common';
import { useIndexUpdate } from '../common/hooks';

const ImprintDe = lazy(() => import('./de/ImprintDe'));
const ImprintEn = lazy(() => import('./en/ImprintEn'));

export function Imprint(props) {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);
    const scroll = useContext(ScrollContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <ImprintDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <ImprintEn />
                        </React.Suspense>
                    :
                        null
                }

                <div className="imprint_links">
                
                    <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_2_black" to="/privacy_policy/">{locale.msgs.PRIVACY_POLICY}</LinkSmart>
                    <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} className="text_2_black" to="/terms_of_use/">{locale.msgs.TOS}</LinkSmart>
                    
                    <div className="text_2_black imprint_privacy_policy"
                            onClick={() => {
                                consumer.setShowCookies(true);
                                // scroll.scrollToPlain(0, 0);
                            }}>
                        {locale.msgs.COOKIE_SETTINGS}
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );
}

export const SuspenseComp = ({}) => {
    const overlay = useContext(OverlayContext);

    useEffect(() => {
        overlay.incrLoadingCounter();
        overlay.setOverlaySolidWhite(true);

        return () => {
            overlay.decrLoadingCounter();
            overlay.setOverlaySolidWhite(false);
        }
    }, []);

    return (
        null
    );
}
